import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Button, Input, Select, Row } from 'antd';
import { useHistory } from 'react-router';
import { useForm, Controller } from 'react-hook-form';

import { useDispatch, useSelector } from 'react-redux';
import GetField from '../Components/GetField';
import styles from '../styles';
import { successNotification, errorNotification } from '../Snackbar';
import Api from '../Api';
import LeftGrid from '../Components/LeftGrid';
import RightGrid from '../Components/RightGrid';
import { states } from '../constants';
import { getVendor, clearVendor } from '../Actions';
import Breadcrumbs from '../Components/Breadcrumbs';

const AntInput = GetField(Input);
const AntSelect = GetField(Select);
const { Option } = Select;
const AntInputTextArea = GetField(Input.TextArea);

const UpdateVendor = props => {
  const { classes, match } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const { handleSubmit, control, reset } = useForm();

  const [confirmLoading, setConfirmLoading] = useState(false);

  const vendor = useSelector(state => state.vendor);

  useEffect(() => {
    dispatch(getVendor(match.params.id));
    return () => {
      dispatch(clearVendor());
    };
  }, []);

  useEffect(() => {
    reset(vendor);
  }, [vendor]);

  const onSubmit = useCallback(async formValues => {
    try {
      setConfirmLoading(true);
      await Api.put(`/vendors/${match.params.id}`, formValues);
      successNotification('Vendor updated');
      history.push('/vendors/list');
    } catch (err) {
      setConfirmLoading(false);
      errorNotification(err);
    }
  }, []);

  return (
    <>
      <Breadcrumbs
        moduleName="Vendor"
        moduleLink="/vendors/list"
        subModuleName="Update"
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <LeftGrid>
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Name"
                  placeholder="Name"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Email"
                  placeholder="Email"
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <Controller
              name="mobile"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Mobile"
                  placeholder="Mobile"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="address"
              control={control}
              render={({ field }) => (
                <AntInputTextArea
                  allowClear
                  label="Address"
                  placeholder="Address"
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <Controller
              name="state"
              control={control}
              render={({ field }) => (
                <AntSelect
                  allowClear
                  label="State"
                  placeholder="Select state"
                  {...field}
                >
                  {states.map(state => (
                    <Option key={state} value={state}>
                      {state}
                    </Option>
                  ))}
                </AntSelect>
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="gstNo"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="GST No"
                  placeholder="GST No"
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <Controller
              name="contactPerson"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Contact Person"
                  placeholder="Contact Person"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="remark"
              control={control}
              render={({ field }) => (
                <AntInputTextArea
                  allowClear
                  label="Remark"
                  placeholder="Remark"
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <Row className={classes.buttonContainer}>
          <Button type="primary" loading={confirmLoading} htmlType="submit">
            Submit
          </Button>
        </Row>
      </form>
    </>
  );
};

UpdateVendor.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default withStyles(styles)(UpdateVendor);
